export default __webpack_public_path__ + "static/media/logo-pokemon.206a73b5.png";